<template>
  <section id="faqs" class="content-block section-padding">
    <div class="mx-auto max-w-(--breakpoint-lg) text-center">
      <h2 class="section-title">Frequently asked questions</h2>
    </div>

    <div
      class="max-w-(--breakpoint-lg) mx-auto mt-16 text-gray-900"
      id="accordion-flush"
      data-accordion="collapse"
      data-active-classes="bg-white text-gray-900"
      data-inactive-classes="text-gray-900"
    >
      <div>
        <h3 id="accordion-flush-heading-3">
          <button
            type="button"
            class="accordion-header"
            data-accordion-target="#accordion-flush-body-3"
            aria-expanded="false"
            aria-controls="accordion-flush-body-3"
          >
            <span>Is it free to use?</span>
            <svg
              data-accordion-icon
              class="w-3 h-3 shrink-0"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5 5 1 1 5"
              />
            </svg>
          </button>
        </h3>
        <div id="accordion-flush-body-3" class="hidden" aria-labelledby="accordion-flush-heading-3">
          <div class="accordion-body">
            <p>Yes, Fitsnack is completely free to use.</p>
          </div>
        </div>
      </div>

      <div>
        <h3 id="accordion-flush-heading-1">
          <button
            type="button"
            class="accordion-header"
            data-accordion-target="#accordion-flush-body-1"
            aria-expanded="false"
            aria-controls="accordion-flush-body-1"
          >
            <span>How do you calculate my burned snacks?</span>
            <svg
              data-accordion-icon
              class="w-3 h-3 shrink-0"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5 5 1 1 5"
              />
            </svg>
          </button>
        </h3>
        <div id="accordion-flush-body-1" class="hidden" aria-labelledby="accordion-flush-heading-1">
          <div class="accordion-body">
            <p>We convert your burned calories into snacks by using each snack's calorie count.</p>
          </div>
        </div>
      </div>

      <div>
        <h3 id="accordion-flush-heading-2">
          <button
            type="button"
            class="accordion-header"
            data-accordion-target="#accordion-flush-body-2"
            aria-expanded="false"
            aria-controls="accordion-flush-body-2"
          >
            <span>Should I eat the snacks I've burned after my workout?</span>
            <svg
              data-accordion-icon
              class="w-3 h-3 shrink-0"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5 5 1 1 5"
              />
            </svg>
          </button>
        </h3>
        <div id="accordion-flush-body-2" class="hidden" aria-labelledby="accordion-flush-heading-2">
          <div class="accordion-body">
            <p>
              No, Fitsnack is just for fun! It shows your burned calories as snacks, but it's not
              meant to encourage eating them. Keep up your healthy diet and exercise routine.
            </p>
          </div>
        </div>
      </div>

      <div>
        <h3 id="accordion-flush-heading-6">
          <button
            type="button"
            class="accordion-header"
            data-accordion-target="#accordion-flush-body-6"
            aria-expanded="false"
            aria-controls="accordion-flush-body-6"
          >
            <span>What Strava activities are supported?</span>
            <svg
              data-accordion-icon
              class="w-3 h-3 shrink-0"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5 5 1 1 5"
              />
            </svg>
          </button>
        </h3>
        <div id="accordion-flush-body-6" class="hidden" aria-labelledby="accordion-flush-heading-6">
          <div class="accordion-body">
            <p>You can use Fitsnack with any Strava activity that tracks your burned calories.</p>
          </div>
        </div>
      </div>

      <div>
        <h3 id="accordion-flush-heading-8">
          <button
            type="button"
            class="accordion-header"
            data-accordion-target="#accordion-flush-body-8"
            aria-expanded="false"
            aria-controls="accordion-flush-body-8"
          >
            <span>What data do you save?</span>
            <svg
              data-accordion-icon
              class="w-3 h-3 shrink-0"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5 5 1 1 5"
              />
            </svg>
          </button>
        </h3>
        <div id="accordion-flush-body-8" class="hidden" aria-labelledby="accordion-flush-heading-8">
          <div class="accordion-body">
            <p>
              We only keep your Strava ID and which snacks you've picked. This lets us add snacks to
              your activities. We don't save any of your activity data.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts"></script>

<style scoped>
a {
  @apply underline;
}
</style>
